import React from 'react'
import { Skeleton } from '@arvoreeducacao/bonsai-ds'
import { Container, TitleWrapper, BooksWrapper } from './ShelfSkeleton.styles'
import { SKELETON_SIZES } from './ShelfSkeleton.constants'
import type { ShelfSkeletonProps } from './types'

const ShelfSkeleton: React.FC<ShelfSkeletonProps> = ({
  itemsCount = 6,
  type = 'books'
}) => {
  const { width, height } = SKELETON_SIZES[type]

  return (
    <Container>
      <TitleWrapper>
        <Skeleton
          height={'68px'}
          width={'100%'}
          style={{ borderRadius: '10px' }}
        />
      </TitleWrapper>
      <BooksWrapper>
        {Array.from({ length: itemsCount }).map((_, index) => (
          <Skeleton
            key={index}
            width={`${width}px`}
            height={`${height}px`}
            style={{ borderRadius: '10px' }}
          />
        ))}
      </BooksWrapper>
    </Container>
  )
}

export default ShelfSkeleton
